import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import EsimUpgradeBlockData from "../../../Models/Content/EsimUpgradeBlockData";
import EsimUpgradeBlock from "./EsimUpgradeBlock";

export default class EsimUpgradeBlockWrapper extends EpiComponent<EsimUpgradeBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["esim-upgrade-block"];

    return (
      <div className={cssClasses.join(" ")}>
        <EsimUpgradeBlock iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
